export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    program: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    mainHeaderLogo: string;
    headerLogo: string;
    headerLogoAltuviiioPatient: string;
    headerLogoAltuviiioHCP: string;
    headerLogoEloctate: string;
    genzymeLogo: string;
    LogoEloctate: string;
    LogoAlprolix: string;
    LogoAltuviiio: string;
    LogoAltuviiioHcp: string;
    LogoQfitlia: string;
    LogoWayrilz: string;
    NoImage: string;
    LogoSarclisaHcp: string;
    headerLogoAlprolix: string;
    footerLogo: string;
    footerDrugLogo: string;
    footerPharmaLogo: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    
    hasBeenPrescribedQuestion: string;
    hasBeenPrescribedAnswerYes: string;
    hasBeenPrescribedAnswerNo: string;

    isCommerciallyInsuredQuestion: string;
    isCommerciallyInsuredAnswerYes: string;
    isCommerciallyInsuredAnswerNo: string;

    isFederalQuestion: string;
    isFederalAnswerYes: string;
    isFederalAnswerNo: string;

    isUSResidentQuestion: string;
    isUSResidentAnswerYes: string;
    isUSResidentAnswerNo: string;

    iConsentQuestion: string;
    iConsentAnswerYes: string;

    eligibility_1_question: string;
    eligibility_2_question: string;
    eligibility_4_question: string;
    eligibility_5_question: string;
    
    enrollmentTypeQuestion: string;
    enrollmentTypePatient: string;
    enrollmentTypeHCP: string;
    isFederalQuestionIdPatient: string;
    isFederalAnswerYesIdPatient: string;
    isFederalAnswerNoIdPatient: string;
    isFederalQuestionIdHCP: string;
    isFederalAnswerYesIdHCP: string;
    isFederalAnswerNoIdHCP: string;
    isFederalAnswerYesIdHcpWayrilz: string;
    isFederalAnswerNoIdHCPQfitlia: string;
    isFederalQuestionIdHcpWayrilz: string;
    isCommerciallyInsuredQuestionIdPatient: string;
    isCommerciallyInsuredAnswerYesIdPatient: string;
    isCommerciallyInsuredAnswerNoIdPatient: string;
    isCommerciallyInsuredQuestionIdHcp: string;
    isCommerciallyInsuredAnswerYesIdHcp: string;
    isCommerciallyInsuredAnswerNoIdHcp: string;
    isCommerciallyInsuredQuestionIdHcpQfitlia: string;
    isCommerciallyInsuredAnswerYesIdHcpQfitlia: string;
    isCommerciallyInsuredAnswerNoIdHcpQfitlia: string;
    isUSResidentQuestionIdPatient: string;
    isUSResidentAnswerYesIdPatient: string;
    isUSResidentAnswerNoIdPatient: string;
    isAbove18YearsOfAgeQuestionIdPatient: string;
    isAbove18YearsOfAgeAnswerYesIdPatient: string;
    isAbove18YearsOfAgeAnswerNoIdPatient: string;
    marketingOptInQuestionIdPatient: string;
    marketingOptInAnswerYesIdPatient: string;
    marketingOptInAnswerYesIdHcp: string;
    marketingOptInAnswerNoIdHcp: string;
    marketingOptInQuestionIdHcp: string;
    marketingOptInAnswerNoIdPatient: string;
   
    iConsentQuestionIdPatient: string;
    iConsentAnswerYesIdPatient: string;
    iConsentQuestionIdHcp: string;
    iConsentAnswerYesIdHcp: string;
    
    hasBeenPrescribedQuestionIdHcpWayrilz: string;
    hasBeenPrescribedAnswerYesIdHcpWayrilz: string;
    hasBeenPrescribedAnswerNoIdHcpWayrilz: string;
    isUSResidentQuestionIdHcp: string;
    isUSResidentAnswerYesIdHcp: string;
    isUSResidentAnswerNoIdHcp: string;
    eligibility_4_question_patient: string;
    eligibility_4_question_hcp: string;
    eligibility_5_question_patient: string;
    eligibility_5_question_hcp: string;
    eligibility_6_question_patient: string;
    eligibility_6_question_hcp: string;
    eligibility_7_question: string;
    eligibility_7_question_hcp: string;
    patientInfo_1_hcp: string;
    patientInfo_1_patient: string;
    patientInfo_2_patient: string;
    patientInfo_2_hcp: string;
    patientInfo_31_patient: string;
    patientInfo_31_hcp: string;
    patientInfo_32_patient: string;
    patientInfo_32_hcp: string;
    medicationPathName: string;
    eloctatePatient: string;
    eloctateHCP: string;
    alprolixPatient: string;
    qfitliaPatient: string;
    qfitliaHCP: string;
    alprolixHCP: string;
    altuviiioPatient: string;
    altuviiioHCP: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    hideDocumentUpload: string;
    howDoYouQuestionId: string;
    howDoYouTreatProphy: string;
    howDoYouTreatOnDemand: string;
    howDoYouTreatPreferNotToAnswer: string;
    pleaseSelectOneQuestionId: string;
    patientInterestedAlprolix: string;
    hcpInterestedAlprolix: string;
    patientChildAlprolix: string;
    hcpChildAlprolix: string;

    patientInterestedEloctate: string;
    hcpInterestedEloctate: string;
    patientChildEloctate: string;
    hcpChildEloctate: string;

    patientInterestedAltuviiio: string;
    hcpInterestedAltuviiio: string;
    patientChildAltuviiio: string;
    hcpChildAltuviiio: string;
    showSplashPage: string;

    preferredContactMethodQuestionId: string;
    preferredContactMethodEmailAnswerId: string;
    preferredContactMethodPhoneAnswerId: string;
    preferredContactMethodEmailPhoneAnswerId: string;

    COOKIEENVONE:string;
    DATADOMAIN:string;

    rejection_phone: string;
}
